<clp-mw-full-story-w-moving-copy-box *ngIf="data.content['hero_v2']" [data]="data.content['hero_v2']"
	[pageType]="pageType" [tagSectionNum]="'1'">
</clp-mw-full-story-w-moving-copy-box>